import { useBreakpoint } from "@/common/hooks";
import { useGlobalStacks } from "@/state/globalStacks";
import { Button } from "../button";
import { useAppDispatch } from "@/state/redux/hooks";
import { requestOpenTimeSidebar } from "@/state/redux/slices/ui";

export default function CurrentInterval() {
  const globalStacks = useGlobalStacks();
  const name = globalStacks.getName();
  const { isMd } = useBreakpoint();

  const dispatch = useAppDispatch();
  const handleOpenTime = () => {
    dispatch(requestOpenTimeSidebar(true));
  };

  if (isMd) {
    return (
      <span className="font-mono text-[13px] text-muted-foreground">
        {name}
      </span>
    );
  } else {
    return (
      <Button variant="ghost" size="sm" onClick={handleOpenTime}>
        {name}
      </Button>
    );
  }
}
